export default {
  selectItem (state, value) {
    state.selectedItem = value
    state.imageNotSent = ''
  },
  appendNewItem (state, payload) {
    state.registeredItems.push(payload)
  },
  updateRegisteredItems (state, payload) {
    state.registeredItems = state.registeredItems.map((elem) => {
      return elem.id === state.selectedItem.id ? payload : elem
    })
  },
  deleteItem (state, value) {
    state.registeredItems = state.registeredItems.filter(elem => elem.id !== value)
  },
  newItem (state) {
    state.selectedItem = {
      active: true,
      categories: '',
      payments: [],
      photos: [],
      code: '',
      description: '',
      termsOfUseContent: '',
      family: ' ',
      seq: 0,
      id: '',
      name: '',
      price: null,
      priceTable: [],
      priceVariations: false,
      realizationTime: ' ',
      tags: [],
      validityEnd: null,
      validityStart: null,
      image: '',
      images: [],
      imageCropH: 0,
      imageCropW: 0,
      imageCropX: 0,
      imageCropY: 0,
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    }
  },
  toggleLoadingItemAction (state, value) {
    state.loadingItemAction = value
  },
  loadRegisteredItems (state, value) {
    state.registeredItems = value
  },
  changeActivation (state, value) {
    let index = state.registeredItems.findIndex(item => item.id === value)
    state.registeredItems[index].active = !state.registeredItems[index].active
  },
  toggleActive (state) {
    state.selectedItem.active = !state.selectedItem.active
  },
  addPhoto (state, value) {
    state.selectedItem.photos.push(value)
  },
  removePhoto (state, value) {
    state.selectedItem.photos.splice(state.item.selectedItem.indexOf(value), 1)
    state.selectedItem.photos = [...state.selectedItem.photos]
  },
  updateName (state, value) {
    state.selectedItem.name = value
  },
  updateDescription (state, value) {
    state.selectedItem.description = value
  },
  updateTermsOfUseContent (state, value) {
    state.selectedItem.termsOfUseContent = value
  },
  updateCode (state, value) {
    state.selectedItem.code = value
  },
  updateRealizationTime (state, value) {
    state.selectedItem.realizationTime = value
  },
  addTag (state, value) {
    if (state.selectedItem.tags.length > 0) {
      if (state.selectedItem.tags.indexOf(value) !== -1) {
        return false
      } else {
        state.selectedItem.tags.push(value)
      }
    } else {
      (state.selectedItem.tags = []).push(value)
    }
  },
  removeTag (state, value) {
    state.selectedItem.tags.splice(state.selectedItem.tags.indexOf(value), 1)
    state.selectedItem.tags = [...state.selectedItem.tags]
  },
  updateValidityStart (state, value) {
    state.selectedItem.validityStart = value
  },
  updateValidityEnd (state, value) {
    state.selectedItem.validityEnd = value
  },
  updateCategories (state, value) {
    state.selectedItem.categories = value
  },
  updateFamily (state, value) {
    state.selectedItem.family = value
  },
  updateSeq (state, value) {
    state.selectedItem.seq = value
  },
  togglePriceVariations (state) {
    state.selectedItem.priceVariations = !state.selectedItem.priceVariations
    if (state.selectedItem.priceTable.length === 0) {
      state.selectedItem.priceTable.push({price: null, description: '', priceRef: null})
    }
  },
  updateSinglePrice (state, value) {
    state.selectedItem.price = value
  },
  updateMultiPrice (state, payload) {
    state.selectedItem.priceTable[payload.index].price = payload.value
  },
  updatePriceText (state, payload) {
    state.selectedItem.priceTable[payload.index].description = payload.value
  },
  updateMultiPriceRef (state, payload) {
    state.selectedItem.priceTable[payload.index].priceRef = payload.value
  },
  updateMultiPriceImage (state, payload) {
    state.selectedItem.priceTable[payload.index].image = payload.value
  },
  deleteMultiPrice (state, payload) {
    if (state.selectedItem.priceTable.length === 1) {
      state.selectedItem.priceTable = [ { price: '', description: '', priceRef: '', image: '' } ]
    } else {
      state.selectedItem.priceTable = state.selectedItem.priceTable.filter(
        (elem, index) => {
          return index !== payload
        }
      )
    }
  },
  addMultiPrice (state) {
    state.selectedItem.priceTable.push({ price: '', description: '', priceRef: '', image: '' })
  },
  toggleItemModal (state, value) {
    state.itemModal = value
  },
  updatePayments (state, value) {
    state.selectedItem.payments = value
  },
  resetItem (state) {
    state.selectedItem = {}
    state.registeredItems = []
  },
  unshelfImage (state, value) {
    state.imageNotSent = ''
  },
  updateImage (state, value) {
    state.selectedItem.image = value
    state.selectedItem.images = []
  },
  updateImageCrop (state, value) {
    state.selectedItem.imageCropH = parseInt(value.height)
    state.selectedItem.imageCropW = parseInt(value.width)
    state.selectedItem.imageCropY = parseInt(value.y)
    state.selectedItem.imageCropX = parseInt(value.x)
  },
  updateWeekdayStart (state, value) {
    state.selectedItem.weekDayStart = value
  },
  updateWeekdayEnd (state, value) {
    state.selectedItem.weekDayEnd = value
  },
  updateWeekdayInterval (state, value) {
    state.selectedItem.weekDayInterval = value
  },
  updateWeekdayCapacity (state, value) {
    state.selectedItem.weekDayCapacity = value
  },
  updateSundayStart (state, value) {
    state.selectedItem.sundayStart = value
  },
  updateSundayEnd (state, value) {
    state.selectedItem.sundayEnd = value
  },
  updateSundayInterval (state, value) {
    state.selectedItem.sundayInterval = value
  },
  updateSundayCapacity (state, value) {
    state.selectedItem.sundayCapacity = value
  },
  updateMondayStart (state, value) {
    state.selectedItem.mondayStart = value
  },
  updateMondayEnd (state, value) {
    state.selectedItem.mondayEnd = value
  },
  updateMondayInterval (state, value) {
    state.selectedItem.mondayInterval = value
  },
  updateMondayCapacity (state, value) {
    state.selectedItem.mondayCapacity = value
  },
  updateTuesdayStart (state, value) {
    state.selectedItem.tuesdayStart = value
  },
  updateTuesdayEnd (state, value) {
    state.selectedItem.tuesdayEnd = value
  },
  updateTuesdayInterval (state, value) {
    state.selectedItem.tuesdayInterval = value
  },
  updateTuesdayCapacity (state, value) {
    state.selectedItem.tuesdayCapacity = value
  },
  updateWednesdayStart (state, value) {
    state.selectedItem.wednesdayStart = value
  },
  updateWednesdayEnd (state, value) {
    state.selectedItem.wednesdayEnd = value
  },
  updateWednesdayInterval (state, value) {
    state.selectedItem.wednesdayInterval = value
  },
  updateWednesdayCapacity (state, value) {
    state.selectedItem.wednesdayCapacity = value
  },
  updateThursdayStart (state, value) {
    state.selectedItem.thursdayStart = value
  },
  updateThursdayEnd (state, value) {
    state.selectedItem.thursdayEnd = value
  },
  updateThursdayInterval (state, value) {
    state.selectedItem.thursdayInterval = value
  },
  updateThursdayCapacity (state, value) {
    state.selectedItem.thursdayCapacity = value
  },
  updateFridayStart (state, value) {
    state.selectedItem.fridayStart = value
  },
  updateFridayEnd (state, value) {
    state.selectedItem.fridayEnd = value
  },
  updateFridayInterval (state, value) {
    state.selectedItem.fridayInterval = value
  },
  updateFridayCapacity (state, value) {
    state.selectedItem.fridayCapacity = value
  },
  updateSaturdayStart (state, value) {
    state.selectedItem.saturdayStart = value
  },
  updateSaturdayEnd (state, value) {
    state.selectedItem.saturdayEnd = value
  },
  updateSaturdayInterval (state, value) {
    state.selectedItem.saturdayInterval = value
  },
  updateSaturdayCapacity (state, value) {
    state.selectedItem.saturdayCapacity = value
  },
  toggleNeedSchedule (state) {
    state.selectedItem.needSchedule = !state.selectedItem.needSchedule
  },
  toggleCustomTime (state) {
    state.selectedItem.customTime = !state.selectedItem.customTime
  },
  toggleImgUploadModal (state, value) {
    state.imgUploadModal = value
  },
  updateImgUploadImage (state, value) {
    state.imgUploadImage = value
  },
  updateImgUploadIndex (state, value) {
    state.imgUploadIndex = value
  },
  updateImgUploadCrop (state, value) {
    state.itemVariationImage.imageCropH = parseInt(value.height)
    state.itemVariationImage.imageCropW = parseInt(value.width)
    state.itemVariationImage.imageCropY = parseInt(value.y)
    state.itemVariationImage.imageCropX = parseInt(value.x)
  },
  loadCupoms (state, value) {
    state.totalItems = value.totalItens
    state.currentPage = value.paginaAtual
    state.totalPages = value.totalPaginas
    state.cupoms = value.list
    state.paginaInicial = value.paginaInicial
    state.paginaFinal = value.paginaFinal
  },
  cupomNextPage (state) {
    state.cupomCurrentPage ++
  },
  cupomPrevPage (state) {
    state.cupomCurrentPage --
  },
  selectCupom (state, payload) {
    state.selectedCupom = payload
  },
  toggleCupomModal (state, value) {
    state.cupomModal = value
  },
  toggleLoadingCupomAction (state, value) {
    state.loadingCupomAction = value
  },
  appendNewCupom (state, payload) {
    state.cupoms.push(payload)
  },
  updateRegisteredCupons (state, payload) {
    state.cupoms = state.cupoms.map((elem) => {
      return elem.id === state.selectedCupom.id ? payload : elem
    })
  },
  changeItemsPerPage (state, value) {
    state.cupomItemsPerPage = value
  },
  cupomResetPage (state) {
    state.cupomCurrentPage = 1
  },
  updateCupomName (state, value) {
    state.selectedCupom.name = value
  },
  updateCupomType (state, value) {
    state.selectedCupom.type = value
  },
  updateCupomAmount (state, value) {
    state.selectedCupom.amount = value
  },
  updateCupomCode (state, value) {
    state.selectedCupom.code = value
  },
  updateCupomStart (state, value) {
    state.selectedCupom.start = value
  },
  updateCupomEnd (state, value) {
    state.selectedCupom.end = value
  },
  updateCupomLimitationType (state, value) {
    state.selectedCupom.limitationType = value
  },
  updateCupomLimitation (state, value) {
    state.selectedCupom.limitation = value
  },
  updateCupomObservation (state, value) {
    state.selectedCupom.observation = value
  },
  updateCupomProducts (state, value) {
    state.selectedCupom.products = value
  },
  updateCupomActive (state, value) {
    state.selectedCupom.active = value
  },
  toggleProdutos (state) {
    state.selectedCupom.produtos = !state.selectedCupom.produtos
  },
  newCupom (state) {
    state.selectedCupom = {
      id: 0,
      name: '',
      idFornecedor: 0,
      type: 0,
      amount: 0,
      code: null,
      start: null,
      end: null,
      limitationType: 0,
      limitation: null,
      observation: '',
      region: false,
      administradoras: false,
      condominios: false,
      produtos: false,
      active: false,
      approved: false,
      servicoProdutosList: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/item/mutations.js